<template>
  <div>
    <venue-list
      :groupId="groupId"
      :venues="venues"
      :canDelete="true"
      @removeItem="openConfirmationModal"
      @rowClick="openVenue">
      <ez-confirmation-modal ref="deleteModal" type="red">
        <template #title>Delete this {{ $t('global.venue') | lowercase }}?</template>
        <template #content>
          <p>When deleted, this {{ $t('global.venue') | lowercase }}
            will no longer be live on OrderEZ.</p>

          <p>You won’t see this {{ $t('global.venue') | lowercase }}
            in admin panel as well.</p>
        </template>
        <template #footer>
          <ez-button @click="closeDeleteModal" type="link">Cancel</ez-button>
          <ez-button @click="deleteVenue" type="red">Yes, Delete</ez-button>
        </template>
      </ez-confirmation-modal>
    </venue-list>
    <ez-loader :show="isLoading">Loading...</ez-loader>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VenueList from '@/views/common/venues/List.vue';
import Venue from '@/models/Venue';
import EzLoader from '@/components/ui/Loader/EzLoader';
import { EzConfirmationModal } from '@/components/ui/Modal';
import EzButton from '@/components/ui/Button/EzButton';
import flash from '@/components/ui/FlashMessage';

export default {
  components: {
    EzLoader,
    VenueList,
    EzConfirmationModal,
    EzButton,
  },
  props: {
    groupId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    venues() {
      return Venue.query()
        .where('groupId', this.groupId)
        .all();
    },
    ...mapGetters('loading', ['getLoading']),
    isLoading() {
      return this.getLoading('get-venues');
    },
  },
  methods: {
    openVenue({ id }) {
      this.$router.push({
        name: 'admin-venue-info',
        params: { id },
      });
    },
    openConfirmationModal(data) {
      this.itemForDelete = data;
      this.$refs.deleteModal.open();
    },
    closeDeleteModal() {
      this.itemForDelete = {};
      this.$refs.deleteModal.close();
    },
    async deleteVenue() {
      await this.adminDeleteVenue({
        venueId: this.itemForDelete.id,
      });
      await this.fetchVenuesForGroup(this.groupId);
      this.closeDeleteModal();
      flash.success({
        title: `${this.$t('global.venue')} successfully deleted!`,
      });
    },
    ...mapActions('entities/venues', [
      'fetchVenuesForGroup',
      'adminDeleteVenue',
    ]),
    ...mapActions('entities/groups', [
      'fetchGroups',
    ]),
  },
  async mounted() {
    await this.fetchGroups();
    await this.fetchVenuesForGroup(this.groupId);
  },
};
</script>
